import generateUtilityClass from '@mui/utils/generateUtilityClass';
import generateUtilityClasses from '@mui/utils/generateUtilityClasses';
import composeClasses from '@mui/utils/composeClasses';
export function getChatBoxUtilityClass(slot) {
  return generateUtilityClass('MuiChatBox', slot);
}
export const chatBoxClasses = generateUtilityClasses('MuiChatBox', ['root', 'layout', 'conversationsPane', 'threadPane']);
const slots = {
  root: ['root'],
  layout: ['layout'],
  conversationsPane: ['conversationsPane'],
  threadPane: ['threadPane']
};
export const useChatBoxUtilityClasses = classes => composeClasses(slots, getChatBoxUtilityClass, classes);